import { render, staticRenderFns } from "./Distributors.vue?vue&type=template&id=7fd6c27a&scoped=true&"
import script from "./Distributors.vue?vue&type=script&lang=js&"
export * from "./Distributors.vue?vue&type=script&lang=js&"
import style0 from "./Distributors.vue?vue&type=style&index=0&id=7fd6c27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd6c27a",
  null
  
)

export default component.exports